import { memo, useContext } from "react";
import appStyles from "../../../App.module.css";
import { AUBusinessTravelContext } from "../../AUBusinessTravel";
import { IAUBusinessTravelContext } from "../../config/interfaces";

const AUHeader = () => {
  const { currentStep, partnerLogo } = useContext(AUBusinessTravelContext) as IAUBusinessTravelContext;

  return (
    <div
      className={` ${appStyles.MY20} ${
        partnerLogo
          ? [`${appStyles.footerLogosWrap} ${currentStep === 0 ? appStyles.btW576 : appStyles.btW1200}`]
          : appStyles.footerLogosWrapper
      } `}
    >
      {partnerLogo ? (
        <>
          <div className={`${appStyles.partnerLogoWrapper} ${appStyles.partnerLogoImgWrap}`}>
            <img src={partnerLogo} alt="Partner Logo" />
          </div>

          <div className={`${appStyles.poweredbyLogoWrapper} ${appStyles.poweredByBorderLeft}`} />
        </>
      ) : (
        <div className={appStyles.BattleFaceBGLogo}></div>
      )}
    </div>
  );
};

export default memo(AUHeader);
